import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

// salesonepro
import {
  ModalPopupOverlayRef,
} from '@salesonepro/components';
import { StorageService } from '@salesonepro/services';
import {
  SpinnerDirective,
} from '@salesonepro/modules/spinner/spinner.directive';
import {
  IconComponent,
} from '@salesonepro/components/icon/icon.component';


@Component({
  selector: 'app-customer-popup',
  templateUrl: './customer-popup.component.html',
  styleUrls: ['./customer-popup.component.scss'],
  imports: [
    FormsModule,
    SpinnerDirective,
    IconComponent,
    NgClass
  ]
})
export class CustomerPopupComponent {
  modalData = inject(ModalPopupOverlayRef);
  dialogRef = inject<ModalPopupOverlayRef<CustomerPopupComponent>>(ModalPopupOverlayRef);
  private storage = inject(StorageService);


  masterCustomerList = [];
  customerList = [];
  searchInput: string;
  selectedCustomerId: any;
  isLoadRefresh: boolean;
  isLoading: boolean;

  constructor() {
    const modalData = this.modalData;

    this.masterCustomerList = modalData.data.input.customer;
    this.isLoadRefresh = modalData.data.input.refresh;
    this.customerList = this.masterCustomerList;
    if (this.storage.retrieve('selected_customer')) {
      this.selectedCustomerId = this.storage.retrieve('selected_customer').id;
    }
  }

  onClickCustomer(selectedCustomer) {
    this.isLoading = true;
    this.storage.clear('account-details');
    this.storage.clear('cart-id');
    this.dialogRef.close(selectedCustomer);
  }

  onInputSearch() {
    if (this.searchInput) {
      this.customerList = this.masterCustomerList.filter(
        (item) => item.company_name.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1);
    } else {
      this.filterCustomer();
    }
  }

  filterCustomer() {
    this.customerList = this.masterCustomerList;
  }

}